import { Query } from '../../pages/reportFolio/pages/dashboard/typing'
import { ObjectGeneric } from '../types/generals'

const returnQuery = (data: Query, customeEquivalence?: Record<string, string>): string => {
  const equivalence: Record<string, string> = customeEquivalence ?? {
    foliosAmount: 'folio',
    unit: 'store',
    requestDate: 'create',
    solveDate: 'solutionDate',
    timeElapsed: 'solutionTime',
  }
  return `page=${data?.pagination?.page || 1}&size=${data?.pagination?.pageSize || 20}${data?.sort ? `&order=${data?.sort?.sort?.toUpperCase()}&column=${equivalence[data?.sort?.field] ?? data?.sort?.field}` : ''}${data.filter ? `&${data.filter}` : ''}`
}

const returnQueryWithPagination = (data: Query, customeEquivalence?: Record<string, string>): string => {
  const equivalence: Record<string, string> = customeEquivalence ?? {
    foliosAmount: 'folio',
    unit: 'store',
    requestDate: 'create',
    solveDate: 'solutionDate',
    timeElapsed: 'solutionTime',
    available_to: 'end_date',
    available_from: 'start_date'
  }

  return `${data?.sort ? `&order=${data?.sort?.sort?.toUpperCase()}&column=${equivalence[data?.sort?.field] ?? data?.sort?.field}` : ''}${data.filter ? `&${data.filter}` : ''}`
}

const replaceQuery = ({page,query,size}:{query:string;page:number;size:number}) => {
  return query?.replace(`page=${page || 1}&size=${size || 20}`, '')
}

function objectToQueryString(obj: ObjectGeneric, customeEquivalence?: Record<string, string>) {
  const params = new URLSearchParams();

  for (const [key, value] of Object.entries(obj)) {
      if (value !== null && value !== undefined) {
          params.append(customeEquivalence?.[key] ?? key, value);
      }
  }

  return params.toString();
}
export { returnQuery, replaceQuery, returnQueryWithPagination, objectToQueryString }
